export type PresignedPostData = {
	url: string;
	fields: Record<string, string>;
};

export async function uploadToS3(file: File, presignedData: PresignedPostData) {
	const { url, fields } = presignedData;

	const formData = new FormData();

	Object.entries(fields).forEach(([key, value]) => {
		formData.append(key, value);
	});

	formData.append('file', file);

	const response = await fetch(url, {
		method: 'POST',
		body: formData,
	});

	if (!response.ok) {
		const errorText = await response.text();
		throw new Error(`S3 error ${response.status}: ${errorText}`);
	}

	return {
		url,
		key: fields.key,
	};
}
